import * as Yup from 'yup';

export type ChequeNoteType = {
  chequeGiroId: string | null;
  bankAccountId: string | null;
  referenceNumber: string | null;
  issuedAt: Date;
  availableAt: Date;
  expiredAt: Date;
};

export type PaymentItemType = {
  total: number;
  paidAmount: number;

  amount: number;
  tax: number;
  discount: number;
  fee: number;

  isCheck: boolean;

  saleId: string;
  saleRefId: string;
  invoiceNumber: string;
  dueDate: Date | null;
};

export type FormType = {
  transactionAt: Date;
  tempTransactionAt: Date;
  needApproval: boolean;
  number: string;
  refId?: string;
  customerId: string | null;
  description: string;
  paymentItems: PaymentItemType[];
  paymentMethodId: string | null;
  paymentMethod?: string;
  chequeNote: ChequeNoteType | null;
  paymentableId: string | null;
};

export const accountReceivableSchema = () =>
  Yup.object().shape({
    transactionAt: Yup.date().nullable().required(),
    needApproval: Yup.boolean(),
    externalId: Yup.string(),
    customerId: Yup.string().nullable().required(),
    description: Yup.string().nullable(),
    paymentMethodId: Yup.string().nullable().required(),
    paymentMethod: Yup.string(), //Validation
    chequeNote: Yup.object({
      saleRefId: Yup.string().nullable(),
      amount: Yup.number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .min(0),
      tax: Yup.number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .min(0),
      discount: Yup.number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .min(0),
      fee: Yup.number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .min(0),
      saleId: Yup.string().nullable(),
      bankAccountId: Yup.string().nullable(),
    }).nullable(),
    paymentItems: Yup.array().of(
      Yup.object({
        amount: Yup.number()
          .transform((value) => (isNaN(value) ? undefined : value))
          .min(0)
          .required(),
        tax: Yup.number()
          .transform((value) => (isNaN(value) ? undefined : value))
          .min(0)
          .required(),
        discount: Yup.number()
          .transform((value) => (isNaN(value) ? undefined : value))
          .min(0)
          .required(),
        fee: Yup.number()
          .transform((value) => (isNaN(value) ? undefined : value))
          .min(0)
          .required(),
      }),
    ),
  });
